// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"AboutBonusSystem_placeholder__alMGh"};